import { catalogPath, matchingPath } from "router/path";

export const isMatchingPath = (path: string) => path.startsWith(matchingPath);
export const isCatalogPath = (path: string) => path.startsWith(catalogPath);
